module.exports = __webpack_public_path__ + "img/kafalah-pembiayaan-mikro.7fff9f83.jpg";